import { LayoutOptions } from '../types/types';

export const timeSlotLayouts = [
  LayoutOptions.DAILY_TIME_SLOTS_MONTHLY_PICKER,
  LayoutOptions.DAILY_TIME_SLOTS_WEEKLY_PICKER,
  LayoutOptions.WEEKLY_TIME_SLOTS,
];

// The WEEKLY_TIME_SLOTS layout renders a 7-day-per-column grid that is only
// suitable for desktop/tablet widths; on a mobile viewport it overflows and gets
// cropped (SCHED-47751). Since it is not offered as a mobile option, resolve it to
// the mobile-friendly weekly picker layout so the whole widget (rendering, data
// fetching and behavior) treats it consistently as DAILY_TIME_SLOTS_WEEKLY_PICKER
// on mobile.
export const getResolvedCalendarLayout = (
  settings: any,
  settingsParams: any,
  isMobile: boolean,
): LayoutOptions => {
  const calendarLayout: LayoutOptions = settings.get(
    settingsParams.calendarLayout,
  );

  if (isMobile && calendarLayout === LayoutOptions.WEEKLY_TIME_SLOTS) {
    return LayoutOptions.DAILY_TIME_SLOTS_WEEKLY_PICKER;
  }

  return calendarLayout;
};

export const isLayoutWithTimeSlot = (
  settings: any,
  settingsParams: any,
): boolean =>
  timeSlotLayouts.includes(settings.get(settingsParams.calendarLayout));

export const isDailyTimeSlotsMonthlyPickerLayout = (
  settings: any,
  settingsParams: any,
): boolean =>
  settings.get(settingsParams.calendarLayout) ===
  LayoutOptions.DAILY_TIME_SLOTS_MONTHLY_PICKER;

export const isDailyTimeSlotsWeeklyPickerLayout = (
  settings: any,
  settingsParams: any,
  isMobile: boolean,
): boolean =>
  getResolvedCalendarLayout(settings, settingsParams, isMobile) ===
  LayoutOptions.DAILY_TIME_SLOTS_WEEKLY_PICKER;

export const isDailyAgendaWeeklyPickerLayout = (
  settings: any,
  settingsParams: any,
): boolean =>
  settings.get(settingsParams.calendarLayout) ===
  LayoutOptions.DAILY_AGENDA_WEEKLY_PICKER;

export const isWeeklyTimeSlotsLayout = (
  settings: any,
  settingsParams: any,
  isMobile: boolean,
): boolean =>
  getResolvedCalendarLayout(settings, settingsParams, isMobile) ===
  LayoutOptions.WEEKLY_TIME_SLOTS;

export const isWeeklyTimetableLayout = (
  settings: any,
  settingsParams: any,
): boolean =>
  settings.get(settingsParams.calendarLayout) ===
  LayoutOptions.WEEKLY_TIMETABLE;
